const noop = () => {};
const isDev = process.env.NODE_ENV === 'development';

const logger = {
  log: isDev ? Function.prototype.bind.call(console.log, console) : noop,
  error: isDev ? Function.prototype.bind.call(console.error, console) : noop,
  warn: isDev ? Function.prototype.bind.call(console.warn, console) : noop,
};

export default logger;
